import { render } from "./HotTipCard.vue?vue&type=template&id=5eb903cb&scoped=true"
import script from "./HotTipCard.vue?vue&type=script&lang=js"
export * from "./HotTipCard.vue?vue&type=script&lang=js"

import "./HotTipCard.vue?vue&type=style&index=0&id=5eb903cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5eb903cb"

export default script